export var NewsType;
(function (NewsType) {
    NewsType["Feature"] = "feature";
    NewsType["Marketings"] = "marketings";
    NewsType["Banner"] = "banner";
})(NewsType || (NewsType = {}));
